export default __webpack_public_path__ + "static/media/sentiment_angry.db7b6b6f.svg";